import type { CompetencyProfileItemResponse } from '@/types/competencies/CompetencyProfileApi';
import type { Competency } from '@/types/competency/Competency';

/**
 * Determines if a competency is deactivated or removed (Bug 13976, Bug 14075).
 * A competency is deactivated if its status is 'Inactive', it is individually deactivated,
 * or it has been removed (excluded) from the employee's profile.
 */
export const isCompetencyDeactivated = (
    competency: CompetencyProfileItemResponse | Competency,
): boolean => {
    return (
        competency.status === 'Inactive' ||
        competency.isIndividuallyDeactivated === true ||
        (competency as CompetencyProfileItemResponse).isRemoved === true
    );
};

/**
 * Determines if a competency is active (not deactivated) (Bug 13976).
 */
export const isCompetencyActive = (
    competency: CompetencyProfileItemResponse | Competency,
): boolean => {
    return !isCompetencyDeactivated(competency);
};
